import { render } from "./chooseWallet.vue?vue&type=template&id=04784525&scoped=true&lang=pug"
import script from "./chooseWallet.vue?vue&type=script&setup=true&lang=js"
export * from "./chooseWallet.vue?vue&type=script&setup=true&lang=js"

import "./chooseWallet.vue?vue&type=style&index=0&id=04784525&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04784525"]])

export default __exports__